import React from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import checkedIcon from '../../assets/images/checked-radio-icon.svg'
import uncheckedIcon from '../../assets/images/unchecked-radio-icon.svg'

interface CustomRadioWithTooltipProps {
    id: string;
    name: string;
    value: string;
    label: string;
    tooltipText?: string;
    checked: boolean;
    disabled?: boolean;
    onChange: (value: string) => void;
    className?: string;
    showTooltip?: boolean;
}

const CustomRadioWithTooltip: React.FC<CustomRadioWithTooltipProps> = ({
    id,
    name,
    value,
    label,
    tooltipText,
    checked,
    disabled,
    onChange,
    className = '',
    showTooltip = true,
}) => {
    const [isFocused, setIsFocused] = React.useState(false);

    const handleClick = () => {
        if (!disabled) {
            onChange(value);
        }
    };

    return (
        <div className={`form-check com-check d-flex flex-row align-items-center ${className}`}>
            <div
                id={id}
                role="radio"
                aria-checked={checked}
                aria-disabled={disabled}
                tabIndex={disabled ? -1 : 0}
                className="custom-radio-icon cursor-pointer d-flex align-items-center me-2"
                onClick={handleClick}
                onFocus={() => {
                    setIsFocused(true);
                    if (!disabled && !checked) {
                        onChange(value);
                    }
                }}
                onBlur={() => setIsFocused(false)}
                onKeyDown={(e) => {
                    if ((e.key === ' ' || e.key === 'Enter') && !disabled) {
                        e.preventDefault();
                        onChange(value);
                    }
                }}
                style={{
                    position: 'relative',
                    outline: 'none',
                    cursor: disabled ? 'not-allowed' : 'pointer',
                }}
            >
                <img
                    src={checked ? checkedIcon : uncheckedIcon}
                    alt=""
                    aria-hidden="true"
                    style={{
                        width: '20px',
                        height: '20px',
                        transition: 'all 0.2s',
                        display: 'block',
                        opacity: disabled ? 0.4 : 1,
                        filter: disabled ? 'grayscale(100%)' : 'none',
                        cursor: disabled ? 'not-allowed' : 'pointer',
                        outline: isFocused ? '2px solid #5252F6' : 'none',
                        outlineOffset: '2px',
                        borderRadius: '50%',
                    }}
                />
            </div>
            <label
                className="custom-radio-label form-check-label d-flex align-items-center mb-0 cursor-pointer"
                onClick={handleClick}
                style={{ lineHeight: '20px', cursor: disabled ? 'not-allowed' : 'pointer' }}
            >
                {label}
                {showTooltip && tooltipText && (
                    <button
                        type="button"
                        data-tooltip-id={id}
                        className="text-decoration-none cursor-pointer p-0 border-0 bg-transparent ms-2"
                        aria-label={`${label} information`}
                        style={{ display: 'inline', verticalAlign: 'middle' }}
                    >
                        <i className="icon-info"></i>
                    </button>
                )}
            </label>
            {showTooltip && tooltipText && (
                <ReactTooltip
                    style={{
                        zIndex: "1",
                        wordBreak: "break-word",
                        maxWidth: "90%",
                    }}
                    id={id}
                    place="bottom"
                    content={tooltipText}
                />
            )}
        </div>
    );
};


export default CustomRadioWithTooltip;